import React, { HTMLAttributeAnchorTarget, ReactNode } from "react";
import { NavLink } from "react-router-dom";
import cx from "classnames";
import { isInkleMobileApp } from "util/isInkleMobileApp";

export const ConditionalLink = ({
  to,
  children,
  target,
  className = "",
  ...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  to?: string;
  children?: ReactNode;
  target?: HTMLAttributeAnchorTarget;
  className?: string;
}) => {
  if (!to) {
    return <>{children}</>;
  }

  const isExternal =
    to?.startsWith("https://") ||
    to?.startsWith("http://") ||
    to?.startsWith("mailto") ||
    to?.startsWith("tel") ||
    to?.startsWith("www.");

  if (isExternal) {
    // target="_blank" gets intercepted by the OS inside the mobile app's
    // WebView and opens the system browser instead of a new tab (WebViews
    // don't have tabs) — same-window navigation keeps it inside the app.
    let externalTarget = isInkleMobileApp() ? "_self" : target || "_blank";
    return (
      <a
        {...props}
        href={to}
        target={externalTarget}
        rel={externalTarget === "_blank" ? "noreferrer" : undefined}
        className={cx("text-decoration-none t-text-purple", {
          [className]: className,
        })}
      >
        {children}
      </a>
    );
  }

  // The mobile app's WebView has no tabs, so in-app links stay in the same window.
  const internalTarget = isInkleMobileApp() ? undefined : target;

  return (
    <NavLink
      {...props}
      target={internalTarget}
      rel={internalTarget === "_blank" ? "noreferrer" : undefined}
      activeClassName="active-navbar"
      to={to}
      className={cx("text-decoration-none t-text-purple", {
        [className]: className,
      })}
    >
      {children}
    </NavLink>
  );
};
